import { useState } from "react";
import { useNavigate } from "react-router-dom";
import hero from "@/assets/hero-marketplace.jpg";
import { Search, TrendingUp } from "lucide-react";

const TRENDING = ["iPhone 14", "Swift Dezire", "2BHK Flat", "Sofa Set", "Royal Enfield"];

export function Hero() {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = query.trim();
    navigate(q ? `/listings?search=${encodeURIComponent(q)}` : "/listings");
  };

  const handleTrending = (term: string) => {
    navigate(`/listings?search=${encodeURIComponent(term)}`);
  };

  return (
    <section className="relative overflow-hidden border-b border-border bg-[image:var(--gradient-primary)]">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-8 px-4 py-12 md:grid-cols-2 md:py-20">
        <div className="text-primary-foreground">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-xs font-medium backdrop-blur">
            <TrendingUp className="h-3.5 w-3.5" /> Over 1K+ live listings
          </span>
          <h1 className="mt-4 font-heading text-4xl font-bold leading-snug md:text-5xl lg:text-6xl">
            MemAds Free buy &amp; sell anything,<br />right in your city.
          </h1>
          <p className="mt-4 max-w-lg text-base text-white/85 md:text-lg">
            India's most trusted marketplace for cars, properties, mobiles, jobs and more — with verified sellers and safe chat.
          </p>
          <form onSubmit={handleSearch} className="mt-6 flex flex-col gap-3 sm:flex-row">
            <div className="relative flex-1">
              <Search className="absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
              <input
                id="hero-search-input"
                type="search"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="What are you looking for?"
                className="h-12 w-full rounded-xl bg-white pl-11 pr-4 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-accent"
              />
            </div>
            <button
              type="submit"
              id="hero-search-button"
              className="h-12 rounded-xl bg-accent px-6 text-sm font-semibold text-accent-foreground shadow-[var(--shadow-elevated)] transition hover:brightness-105"
            >
              Search
            </button>
          </form>
          <div className="mt-5 flex flex-wrap gap-2 text-xs text-white/80">
            <span>Trending:</span>
            {TRENDING.map((t) => (
              <button
                key={t}
                type="button"
                onClick={() => handleTrending(t)}
                className="rounded-full bg-white/10 px-2.5 py-1 hover:bg-white/20 transition cursor-pointer"
              >
                {t}
              </button>
            ))}
          </div>
        </div>
        <div className="relative hidden md:block">
          <div className="absolute -inset-6 rounded-3xl bg-white/10 blur-2xl" />
          <img
            src={hero}
            alt="Marketplace illustration"
            width={1536}
            height={1024}
            className="relative rounded-3xl bg-white/90 p-4 shadow-2xl"
          />
        </div>
      </div>
    </section>
  );
}